import React, { useState, useEffect, useRef, useCallback } from 'react';
import { api } from '../services/api';

export default function UbigeoInput({ id, label, value, ubigeoId, onChange, hasError }) {
  const [query, setQuery] = useState(value || '');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    setQuery(value || '');
  }, [value]);

  const search = useCallback(async (q) => {
    if (q.length < 3) { setResults([]); setOpen(false); return; }
    setLoading(true);
    try {
      const data = await api.searchUbigeo(q);
      setResults(Array.isArray(data) ? data : []);
      setOpen(true);
    } catch {
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleInput = (e) => {
    const q = e.target.value;
    setQuery(q);
    if (ubigeoId) onChange(null, '');
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => search(q), 380);
  };

  const select = (item) => {
    const dist = item.description || '';
    const prov = item.Province?.description || '';
    const dep  = item.Province?.Department?.description || '';
    const label = `${dist} / ${prov} / ${dep}`;
    setQuery(label);
    setOpen(false);
    onChange(item.id, label);
  };

  const clear = () => {
    setQuery('');
    setOpen(false);
    onChange(null, '');
  };

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="form-group" ref={wrapRef}>
      <label className="form-label" htmlFor={id}>{label}</label>
      <div className="ubigeo-wrap">
        <input
          id={id}
          className={`form-input${hasError ? ' input-error' : ''}${ubigeoId ? ' ubigeo-confirmed' : ''}`}
          type="text"
          placeholder="Escriba distrito, provincia..."
          value={query}
          onChange={handleInput}
          autoComplete="off"
        />
        {loading && <div className="ubigeo-loading">Buscando...</div>}
        {open && results.length > 0 && (
          <ul className="ubigeo-dropdown">
            {results.map((r, i) => (
              <li key={i} onMouseDown={(e) => { e.preventDefault(); select(r); }}>
                <strong>{r.description}</strong>
                <span> / {r.Province?.description} / {r.Province?.Department?.description}</span>
              </li>
            ))}
          </ul>
        )}
        {open && results.length === 0 && !loading && (
          <div className="ubigeo-empty">Sin resultados</div>
        )}
      </div>
    </div>
  );
}
